'use client'
import ImageComponent from "@/components/ui/ImageComponent"

export interface ItemCardDetailsProps {
    url: string;
    alt_name: string;
    item_name: string;
    item_description: string;
    item_price: string;
}

const ItemCardDetails = ({ url, alt_name, item_name, item_description, item_price }: ItemCardDetailsProps) => {
    return (
        <div className="p-4 md:p-6 bg-white space-y-2 md:space-y-6 rounded-[10px] md:rounded-3xl mx-0 md:mx-2">
            <div className="h-auto w-auto rounded-[10px] md:rounded-3xl overflow-hidden">
                <ImageComponent url={url} img_title={alt_name} object_cover={true} />
            </div>
            <div className="main_heading_content_space_y">
                <div className="space-y-2">
                    <div className="flex justify-between items-start gap-6">
                        <h3 className="text-[11px] md:text-lg/[28px] font-semibold text-textf1 line-clamp-1 flex-1" title={item_name}>{item_name}</h3>
                        <h4 className="text-[11px] md:text-lg/[28px] font-semibold text-textf1 w-fit">₹{item_price}</h4>
                    </div>
                    <p className="text-[11px] md:text-sm/[20px] text-textf2 font-normal line-clamp-1">{item_description}</p>
                </div>
                {/* <Button className="w-full text-center silverblue_btn rounded-full h-8 md:h-12">Add to Cart</Button> */}
            </div>
        </div>
    )
}

export default ItemCardDetails